import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "submenu"];

  connect() {
    document.addEventListener("click", this.clickOutside.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutside.bind(this));
  }

  toggleMenu(event) {
    event.stopPropagation();
    this.menuTarget.classList.toggle("hidden");
  }

  toggleSubmenu(event) {
    event.preventDefault();
    event.stopPropagation();
    const submenu = event.currentTarget.nextElementSibling;
    submenu.classList.toggle("hidden");
  }

  navigate(event) {
    event.stopPropagation();
    // Exemple : gérer l'état actif
    const links = this.element.querySelectorAll("li a");
    links.forEach(link => link.classList.remove("active"));
    event.currentTarget.classList.add("active");

    // Si vous voulez fermer le menu après la navigation
    this.menuTarget.classList.add("hidden");
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden");
      this.submenuTargets.forEach(submenu => submenu.classList.add("hidden"));
    }
  }
}